import { z } from 'zod';

export const zodInvoicePossibleAssigneesQueryParamsSchema = z.object({
  limit: z.number().int().min(1).max(500).optional(),
  offset: z.number().int().min(0).optional(),
  searchString: z.string().trim().optional(),
});

export const zodInvoicePossibleAssigneeSchema = z.object({
  email: z.string(),
  firstName: z.string().nullish(),
  id: z.uuid(),
  lastName: z.string().nullish(),
});

export const zodInvoicePossibleAssigneesResponseSchema = z.object({
  data: z.array(zodInvoicePossibleAssigneeSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
});
